import {DunningService} from "./service/api/dunning.service";
import {DunningProposalService} from "./service/api/dunning-proposal.service";
import {DunningTypeService} from "./service/api/dunning-type.service";
import {DunningPaymentPlanService} from "./service/api/dunning-payment-plan.service";
import {DunningHandOverService} from "./service/api/dunning-hand-over.service";
import {DunningPaymentDistributionService} from "./service/api/dunning-payment-distribution.service";
import {DunningTypeTagService} from "./service/api/dunning-type-tag.service";
import {DunningTagService} from "./service/api/dunning-tag.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {DunningObjectComponent} from "./component/object/dunning-object/dunning-object.component";
import {DunningTypeObjectComponent} from "./component/object/dunning-type-object/dunning-type-object.component";
import {
    DunningPaymentPlanObjectComponent
} from "./component/object/dunning-payment-plan-object/dunning-payment-plan-object.component";
import {
    DunningHandOverObjectComponent
} from "./component/object/dunning-hand-over-object/dunning-hand-over-object.component";
import {
    DunningPaymentDistributionObjectComponent
} from "./component/object/dunning-payment-distribution-object/dunning-payment-distribution-object.component";
import {
    DunningProposalObjectComponent
} from "./component/object/dunning-proposal-object/dunning-proposal-object.component";

export const BD_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['bd.Dunning', {route: '/bd/dunnings', service: DunningService, objectComponent: [{component: DunningObjectComponent}]}],
            // DunningProposal Review-Gate (Mahnvorschläge) — detail view opened via the
            // framework navigation service from the review tab + dashboard workbench.
            ['bd.DunningProposal', {route: '/bd/dunningProposals', service: DunningProposalService, objectComponent: [{component: DunningProposalObjectComponent}]}],
            ['bd.DunningType', {route: '/bd/dunningTypes', service: DunningTypeService, objectComponent: [{component: DunningTypeObjectComponent}]}],
            ['bd.DunningTypeLevel', {route: '/bd/dunningTypeLevels'}],
            ['bd.DunningLevel', {route: '/bd/dunningLevels'}],
            ['bd.DunningLevelAction', {route: '/bd/dunningLevelActions'}],
            ['bd.DunningPaymentPlan', {route: '/bd/dunningPaymentPlans', service: DunningPaymentPlanService, objectComponent: [{component: DunningPaymentPlanObjectComponent}]}],
            ['bd.DunningPaymentPlanCharge', {route: '/bd/dunningPaymentPlanCharges'}],
            ['bd.DunningPaymentPlanContract', {route: '/bd/dunningPaymentPlanContracts'}],
            ['bd.DunningPaymentPlanOneTimePayment', {route: '/bd/dunningPaymentPlanOneTimePayments'}],
            ['bd.DunningPaymentPlanSlip', {route: '/bd/dunningPaymentPlanSlips'}],
            ['bd.DunningHandOver', {route: '/bd/dunningHandOvers', service: DunningHandOverService, objectComponent: [{component: DunningHandOverObjectComponent}]}],
            ['bd.DunningHandOverCharge', {route: '/bd/dunningHandOverCharges'}],
            ['bd.DunningHandOverContract', {route: '/bd/dunningHandOverContracts'}],
            ['bd.DunningHandOverManualTransaction', {route: '/bd/dunningHandOverManualTransactions'}],
            ['bd.DunningPaymentDistribution', {route: '/bd/dunningPaymentDistributions', service: DunningPaymentDistributionService, objectComponent: [{component: DunningPaymentDistributionObjectComponent}]}],
            ['bd.DunningPaymentDistributionCharge', {route: '/bd/dunningPaymentDistributionCharges'}],
            ['bd.DunningPaymentDistributionContract', {route: '/bd/dunningPaymentDistributionContracts'}],
            ['bd.DunningContract', {route: '/bd/dunningContracts'}],
            ['bd.DunningTypeCharge', {route: '/bd/dunningTypeCharges'}],
            ['bd.DunningTypeStart', {route: '/bd/dunningTypeStarts'}],
            ['bd.DunningTypeStop', {route: '/bd/dunningTypeStops'}],
            ['bd.DunningTypeLevelAction', {route: '/bd/dunningTypeLevelActions'}],
            ['bd.DunningTypeLevelTransition', {route: '/bd/dunningTypeLevelTransitions'}],
            ['bd.DunningTypeManualTransaction', {route: '/bd/dunningTypeManualTransactions'}],
            ['bd.DunningArtificialAgent', {route: '/bd/dunningArtificialAgents'}],
            ['bd.DunningTypeOneTimePayment', {route: '/bd/dunningTypeOneTimePayments'}],
            ['bd.DunningTypeTag', {route: '/bd/dunningTypeTags', service: DunningTypeTagService}],
            ['bd.DunningTag', {route: '/bd/dunningTags', service: DunningTagService}],
            // Paket F: fachlich pflegbare Eskalationspolitik (generisches CRUD-Widget).
            ['bd.DunningPlanEscalationConfig', {route: '/bd/dunningPlanEscalationConfigs'}],
            // TM-1000001931 (G): Neue Config-Entity "Zahlungsplan-Herkunft" — route-only,
            // kein Custom-Service benötigt (Standard-CRUD genügt für das Config-Widget).
            ['bd.DunningPaymentPlanSourceType', {route: '/bd/dunningPaymentPlanSourceTypes'}],
            // TM-1000001932: Tracker-Entities der saldoneutralen "Vorausbuchung
            // angenommener Stornos/Wiederinkraftsetzungen" — route-only (generisches CRUD).
            // Die Read-Logik (aktive Vorausbuchungen je Mahnung/Plan inkl. Kind-Zeilen)
            // liegt im providedIn:'root' BdAnticipatedStornoBookingService.
            ['bd.DunningAnticipatedStornoBooking', {route: '/bd/dunningAnticipatedStornoBookings'}],
            ['bd.DunningAnticipatedStornoBookingContract', {route: '/bd/dunningAnticipatedStornoBookingContracts'}],
            // TM-1000001933: Scope-behaftete Stornogrund-Zuordnung je DunningType —
            // route-only (Standard-CRUD genügt für das Config-Widget auf der Config-Page).
            ['bd.DunningTypeTerminationReason', {route: '/bd/dunningTypeTerminationReasons'}],
            // TM-1000001958: Konfigurierbarer Mahnpause-Grund je DunningType —
            // route-only (Standard-CRUD genügt für den Pause-Grund-Editor auf der Config-Page).
            ['bd.DunningTypePauseReason', {route: '/bd/dunningTypePauseReasons'}],
            // bd-dunningtype-overview: Erweiterungspunkte je DunningType (Requirement §7.10) —
            // route-only, Backend-Controller existiert bereits (DunningTypeExitController,
            // /mvsa/bd/dunningTypeExits). Ohne diesen Eintrag liefert
            // MvsCoreService.getCrudService('bd.DunningTypeExit') null.
            ['bd.DunningTypeExit', {route: '/bd/dunningTypeExits'}],
            // bd-dunningtype-overview: Sonderbehandlungs-Regeln je Mahnstufe (Requirement §7.9).
            // route-only. Backend-Controller (DunningTypeLevelSpecialHandlingController,
            // /mvsa/bd/dunningTypeLevelSpecialHandlings) wird parallel vom Backend-Implementierer
            // ergaenzt — Entity/Repository/Access/DtoDetail existierten bereits.
            // BdDunningTypeStructureService.getLevelSpecialHandlings() faengt einen 404 waehrend
            // der Uebergangszeit ueber catchError() ab und liefert [] statt zu fehlern.
            ['bd.DunningTypeLevelSpecialHandling', {route: '/bd/dunningTypeLevelSpecialHandlings'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
